export default {
  headerContainer:
    'shadow-lg! h-full p-2 h-fit! sm:h-fit! sm:p-4 z-10 md:h-fit!',
  orderSubText: 'divide-x divide-black',
  headerBtn: 'bg-[#E0E0E0]! text-black!',
};
